import { MAIL_GOOGLE_OAUTH_ENABLED } from "@/lib/constants/googleOAuth";
import { isMicrosoftOAuthMailAccount } from "@/lib/accounts/microsoftOAuthAccounts";
import type { MailAccountSummary } from "@/lib/types/mail";

/** Compte Gmail (OAuth ou mdp app) — snooze overlay sans MOVE IMAP. */
export function isGmailMailAccount(
  account: Pick<MailAccountSummary, "authType" | "providerId"> | null | undefined
): boolean {
  if (account == null) return false;
  if (account.authType === "oauth_google") return true;
  return account.providerId === "gmail";
}

/**
 * Compte Google à suspendre (pas de sync IMAP) — uniquement tant que OAuth est OFF.
 * Si le flag est ON, ne jamais suspendre : sinon IMAP reste en pause après réactivation.
 */
export function isGoogleOAuthMailAccount(account: MailAccountSummary): boolean {
  if (MAIL_GOOGLE_OAUTH_ENABLED) return false;
  if (account.authType === "oauth_google") return true;
  /* Fallback tant qu’OAuth est off — suspend aussi les Gmail app-password. */
  if (account.providerId === "gmail") return true;
  return false;
}

/** Comptes éligibles sync IMAP / prefetch / live (hors Google OAuth suspendu). */
export function filterAccountsForMailSync(
  accounts: MailAccountSummary[]
): MailAccountSummary[] {
  return accounts.filter(
    (account) => !isGoogleOAuthMailAccount(account) && !isMicrosoftOAuthMailAccount(account)
  );
}
